// "use client";

// import React, { useState, useRef, useEffect } from "react";
// import {
//   Box,
//   Grid,
//   TextField,
//   IconButton,
//   Typography,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Paper,
//   SelectChangeEvent,
//   Button,
//   Popover,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   FormControlLabel,
//   Switch,
// } from "@mui/material";
// import {
//   Cancel,
//   Add as AddIcon,
//   EmojiEmotions,
//   ArrowUpward,
//   ArrowDownward,
//   AddCircleOutline,
//   Delete,
// } from "@mui/icons-material";

// import data from "@emoji-mart/data";
// import Picker from "@emoji-mart/react";
// import DragDrop from "../../components/drag-drop/DragDrop";
// import { Program } from "../../../core/models/db";
// import { useProgram } from "../../../core/hooks/db/fisioteduca/useFisioteduca";


// /**
//  * Interfaz unificada con TODOS los tipos,
//  * incluyendo las propiedades para 'banner'.
//  */
// export interface ContentBlock {
//   type: string;

//   /* Para "text", "text_image_*", "text_video_*", etc. */
//   title?: string;    // máx. 80
//   content?: string;  // máx. 500
//   quote?: string;
//   image?: string;    // para 'image', 'listImage', o 'text_image_*'
//   videoUrl?: string;

//   /* Para "list" */
//   listItems?: string[];
//   // (Opcionalmente podrías usar listImage?: string; si la quieres separar)

//   /* Para "testimonial" */
//   testimonials?: {
//     testimonialName: string;
//     testimonialDescription: string;
//   }[];

//   /* Para "image_text_block" */
//   imageTextItems?: { image?: string; text: string }[];

//   /* El background ("sin_fondo", "claro") */
//   background?: string;

//   /* ------- PARA EL "banner" ------- */
//   // Distintas imágenes para responsive
//   imageMobile?: string;
//   imageTablet?: string;
//   imageDesktop?: string;
//   imageHeight?: "muy_alto" | "alto" | "normal" | "bajo" | "muy_bajo";

//   // Texto principal
//   subTitle?: string;         // Subtítulo
//   textList?: string[];       // Array de líneas
//   textAlign?: "left" | "center" | "right";
//   textColor?: string;

//   // Botón
//   showButton?: boolean;
//   buttonShape?: "rounded" | "square";
//   buttonBgColor?: string;
//   buttonTextColor?: string;
//   buttonText?: string;
//   buttonLink?: string;
// }

// // Para el EmojiPicker
// interface EmojiPickerState {
//   anchorEl: HTMLElement | null;
//   field: string | null;
//   listItemIndex?: number;
// }

// interface ContentBlockFormProps {
//   index: number;
//   block: ContentBlock;
//   onChange: (block: ContentBlock, index: number) => void;
//   onRemove: (index: number) => void;
//   onReorder: (oldIndex: number, newIndex: number) => void;
//   maxPosition: number;
//   disabled?: boolean;
// }

// const ContentBlockFormHome: React.FC<ContentBlockFormProps> = ({
//   index,
//   block,
//   onChange,
//   onRemove,
//   onReorder,
//   maxPosition,
//   disabled,
// }) => {
//   const [openReorderModal, setOpenReorderModal] = useState(false);
//   const [desiredPosition, setDesiredPosition] = useState(index + 1);


//   const { getPrograms } = useProgram();
//   const [programList, setProgramList] = useState<Program[]>([]);
//   const [programSelected, setProgramSelected] = useState<Program | null>(null);


//   const getProgramsAction = async () => {

//     if (programList) return;

//     try {
//       const response = await getPrograms({
//         page: 1,
//         itemsPerPage: 200
//       });

//       console.log("Programas", response);
//       if (response?.ok && response.item.rows.length > 0) {
//         setProgramList(response);
//       } else {
//         setProgramList([]);
//       }

//     } catch (error) {
//       console.error("Error al obtener programas", error);
//       setProgramList([]);
//     }
//   }

//   useEffect(() => {
//     getProgramsAction();
//   }, [block?.type === "banner"]);


//   // Para el EmojiPicker
//   const [emojiPickerState, setEmojiPickerState] = useState<EmojiPickerState | null>(null);

//   // ========== Para Banner (destacar selección) ==========
//   // (Aunque podrías usar estas refs en más casos, aquí se usan en el 'banner')
//   const titleRef = useRef<HTMLTextAreaElement | HTMLInputElement>(null);
//   const subTitleRef = useRef<HTMLTextAreaElement | HTMLInputElement>(null);
//   const textLineRefs = useRef<(HTMLInputElement | null)[]>([]);

//   // Mover / Eliminar
//   const handleRemoveBlock = () => onRemove(index);
//   const handleMoveUp = () => onReorder(index, index - 1);
//   const handleMoveDown = () => onReorder(index, index + 1);

//   // =========================================================
//   // 1) Cambiar el "type" => reiniciar campos según sea necesario
//   // =========================================================
//   const handleTypeChange = (e: SelectChangeEvent<string>) => {
//     const selectedType = e.target.value;

//     let newBlock: ContentBlock = {
//       type: selectedType,
//       background: "sin_fondo",
//     };

//     if (selectedType.startsWith("text")) {
//       newBlock.title = "";
//       newBlock.content = "";
//     } else if (selectedType === "image") {
//       newBlock.image = "";
//     } else if (selectedType === "video") {
//       newBlock.videoUrl = "";
//     } else if (selectedType === "quote") {
//       newBlock.quote = "";
//     } else if (selectedType === "list") {
//       newBlock.title = "";
//       newBlock.listItems = [""];
//     } else if (selectedType === "testimonial") {
//       newBlock.testimonials = [
//         { testimonialName: "", testimonialDescription: "" },
//       ];
//     } else if (selectedType === "image_text_block") {
//       newBlock.imageTextItems = [{ text: "" }];
//     } else if (selectedType === "banner") {
//       // Inicializamos las propiedades del banner
//       newBlock.imageMobile = "";
//       newBlock.imageTablet = "";
//       newBlock.imageDesktop = "";
//       newBlock.imageHeight = "normal";
//       newBlock.title = "";
//       newBlock.subTitle = "";
//       newBlock.textList = [];
//       newBlock.textColor = "#000000";
//       newBlock.textAlign = "left";
//       newBlock.showButton = false;
//       newBlock.buttonShape = "rounded";
//       newBlock.buttonBgColor = "#0066cc";
//       newBlock.buttonTextColor = "#ffffff";
//     }

//     onChange(newBlock, index);
//   };

//   // =========================================================
//   // 2) Handlers genéricos (inputs, selects)
//   // =========================================================
//   const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//     onChange({ ...block, [e.target.name]: e.target.value }, index);
//   };

//   const handleSelectChange = (e: SelectChangeEvent<string>) => {
//     onChange({ ...block, [e.target.name]: e.target.value }, index);
//   };

//   // =========================================================
//   // 3) Drag & Drop: imagen principal (p.ej., para "image", "listImage", etc.)
//   // =========================================================
//   const handleFiles = (files: any[]) => {
//     if (files.length > 0 && files[0].blob) {
//       const file = files[0];
//       const url = URL.createObjectURL(file.blob);
//       onChange({ ...block, image: url }, index);
//     } else if (files.length === 0) {
//       onChange({ ...block, image: "" }, index);
//     }
//   };

//   // =========================================================
//   // 4) LIST (listItems)
//   // =========================================================
//   const handleListItemChange = (itemValue: string, itemIndex: number) => {
//     if (!block.listItems) return;
//     const newListItems = [...block.listItems];
//     newListItems[itemIndex] = itemValue;
//     onChange({ ...block, listItems: newListItems }, index);
//   };
//   const handleAddListItem = () => {
//     if (!block.listItems) return;
//     if (block.listItems.length >= 10) return;
//     onChange({ ...block, listItems: [...block.listItems, ""] }, index);
//   };
//   const handleRemoveListItem = (itemIndex: number) => {
//     if (!block.listItems) return;
//     const newItems = block.listItems.filter((_, i) => i !== itemIndex);
//     onChange({ ...block, listItems: newItems }, index);
//   };

//   // =========================================================
//   // 5) TESTIMONIAL
//   // =========================================================
//   const handleTestimonialChange = (
//     e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
//     tIndex: number,
//     field: "testimonialName" | "testimonialDescription"
//   ) => {
//     if (!block.testimonials) return;
//     const newTestimonials = [...block.testimonials];
//     newTestimonials[tIndex] = {
//       ...newTestimonials[tIndex],
//       [field]: e.target.value,
//     };
//     onChange({ ...block, testimonials: newTestimonials }, index);
//   };
//   const handleAddTestimonial = () => {
//     if (block.testimonials && block.testimonials.length < 8) {
//       onChange(
//         {
//           ...block,
//           testimonials: [
//             ...block.testimonials,
//             { testimonialName: "", testimonialDescription: "" },
//           ],
//         },
//         index
//       );
//     }
//   };
//   const handleRemoveTestimonial = (tIndex: number) => {
//     if (!block.testimonials) return;
//     const newTestimonials = block.testimonials.filter((_, i) => i !== tIndex);
//     onChange({ ...block, testimonials: newTestimonials }, index);
//   };

//   // =========================================================
//   // 6) image_text_block
//   // =========================================================
//   const handleListImageFiles = (
//     files: any[],
//     blockArray: { image?: string; text: string }[],
//     itemIndex: number
//   ) => {
//     const newItems = blockArray ? [...blockArray] : [];
//     if (files.length > 0 && files[0].blob) {
//       const file = files[0];
//       const url = URL.createObjectURL(file.blob);
//       newItems[itemIndex] = { ...newItems[itemIndex], image: url };
//     } else if (files.length === 0) {
//       newItems[itemIndex] = { ...newItems[itemIndex], image: "" };
//     }
//     onChange({ ...block, imageTextItems: newItems }, index);
//   };

//   // =========================================================
//   // 7) EmojiPicker
//   // =========================================================
//   const handleEmojiButtonClick = (
//     field: string,
//     e: React.MouseEvent<HTMLElement>,
//     listItemIndex?: number
//   ) => {
//     if (disabled) return;
//     setEmojiPickerState({ anchorEl: e.currentTarget, field, listItemIndex });
//   };

//   const handleEmojiSelect = (emoji: any) => {
//     if (!emojiPickerState || !emojiPickerState.field) return;
//     const emojiChar = emoji.native;

//     // List item
//     if (
//       emojiPickerState.field === "listItem" &&
//       typeof emojiPickerState.listItemIndex === "number" &&
//       block.listItems
//     ) {
//       const i = emojiPickerState.listItemIndex;
//       const newText = block.listItems[i] + emojiChar;
//       handleListItemChange(newText, i);
//     }
//     // Testimonial description
//     else if (
//       emojiPickerState.field === "testimonialDescription" &&
//       typeof emojiPickerState.listItemIndex === "number" &&
//       block.testimonials
//     ) {
//       const i = emojiPickerState.listItemIndex;
//       const oldText = block.testimonials[i].testimonialDescription || "";
//       const newText = oldText + emojiChar;
//       handleTestimonialChange(
//         { target: { value: newText } } as any,
//         i,
//         "testimonialDescription"
//       );
//     }
//     // En caso de "quote", "content", etc.
//     else {
//       const fieldName = emojiPickerState.field as keyof ContentBlock;
//       const currentText = block[fieldName] || "";
//       onChange({ ...block, [fieldName]: currentText + emojiChar }, index);
//     }
//     setEmojiPickerState(null);
//   };

//   const handleEmojiClose = () => setEmojiPickerState(null);

//   // =========================================================
//   // 8) "Destacar Selección" (exclusivo BANNER)
//   // =========================================================
//   const handleHighlightSelection = (field: "title" | "subTitle") => {
//     const inputRef = field === "title" ? titleRef.current : subTitleRef.current;
//     if (!inputRef) return;

//     const start = inputRef.selectionStart;
//     const end = inputRef.selectionEnd;
//     if (start === null || end === null || start === end) return;

//     const content = block[field] || "";
//     const before = content.slice(0, start);
//     const selection = content.slice(start, end);
//     const after = content.slice(end);
//     const newContent = `${before}<destacar>${selection}</destacar>${after}`;

//     onChange({ ...block, [field]: newContent }, index);
//   };

//   const handleHighlightLine = (lineIndex: number) => {
//     const input = textLineRefs.current[lineIndex];
//     if (!input) return;
//     const { selectionStart: start, selectionEnd: end } = input;
//     if (start === null || end === null || start === end) return;

//     const line = block.textList?.[lineIndex] || "";
//     const before = line.slice(0, start);
//     const selection = line.slice(start, end);
//     const after = line.slice(end);
//     const newLine = `${before}<destacar>${selection}</destacar>${after}`;

//     const newList = [...(block.textList || [])];
//     newList[lineIndex] = newLine;
//     onChange({ ...block, textList: newList }, index);
//   };

//   // Para contar caracteres de "content"
//   const contentLength = block.content ? block.content.length : 0;

//   return (
//     <Paper
//       elevation={3}
//       sx={{
//         p: 3,
//         mb: 3,
//         backgroundColor: disabled ? "grey.100" : "background.paper",
//         position: "relative",
//       }}
//     >
//       {/* Cabecera */}
//       <Grid container justifyContent="space-between" alignItems="center">
//         <Grid item>
//           <Typography variant="h6">Bloque de Contenido #{index + 1}</Typography>
//         </Grid>
//         <Grid item>
//           {!disabled && (
//             <>
//               <Button
//                 variant="outlined"
//                 sx={{ mr: 2 }}
//                 onClick={() => {
//                   setDesiredPosition(index + 1);
//                   setOpenReorderModal(true);
//                 }}
//               >
//                 MOVER
//               </Button>
//               <IconButton
//                 onClick={() => handleRemoveBlock()}
//                 disabled={disabled}
//                 aria-label="Eliminar bloque"
//                 color="error"
//               >
//                 <Cancel />
//               </IconButton>
//             </>
//           )}
//         </Grid>
//       </Grid>

//       {/* Diálogo para reordenar */}
//       <Dialog open={openReorderModal} onClose={() => setOpenReorderModal(false)}>
//         <DialogTitle>Mover Bloque de Contenido</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Indica la posición a la que deseas mover este bloque (1 a {maxPosition}).
//           </DialogContentText>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Posición"
//             type="number"
//             fullWidth
//             variant="standard"
//             value={desiredPosition}
//             onChange={(e) => setDesiredPosition(Number(e.target.value))}
//             onBlur={() => {
//               let val = Number(desiredPosition);
//               if (isNaN(val) || val < 1) val = 1;
//               else if (val > maxPosition) val = maxPosition;
//               setDesiredPosition(val);
//             }}
//             inputProps={{ min: 1, max: maxPosition }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenReorderModal(false)}>Cancelar</Button>
//           <Button
//             onClick={() => {
//               onReorder(index, desiredPosition - 1);
//               setOpenReorderModal(false);
//             }}
//             variant="contained"
//           >
//             Aceptar
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Contenido principal */}
//       <Box mt={2}>
//         <Grid container spacing={3}>
//           {/* Seleccionar Tipo */}
//           <Grid item xs={12} sm={6}>
//             <FormControl fullWidth variant="standard">
//               <InputLabel>Tipo de Contenido</InputLabel>
//               <Select
//                 name="type"
//                 value={block.type || ""}
//                 onChange={handleTypeChange}
//                 disabled={disabled}
//               >
//                 <MenuItem value="text">Texto</MenuItem>
//                 <MenuItem value="text_image_right">Texto - Imagen Derecha</MenuItem>
//                 <MenuItem value="text_image_left">Texto - Imagen Izquierda</MenuItem>
//                 <MenuItem value="text_video_right">Texto - Video Derecha</MenuItem>
//                 <MenuItem value="text_video_left">Texto - Video Izquierda</MenuItem>
//                 <MenuItem value="image">Imagen</MenuItem>
//                 <MenuItem value="video">Video</MenuItem>
//                 <MenuItem value="quote">Cita</MenuItem>
//                 <MenuItem value="list">Listado de Puntos Claves</MenuItem>
//                 <MenuItem value="testimonial">Testimonios</MenuItem>
//                 <MenuItem value="image_text_block">Imágenes con Texto</MenuItem>
//                 {/* ¡AÑADIMOS BANNER! */}
//                 <MenuItem value="banner">Banner</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* Color de Fondo */}
//           <Grid item xs={12} sm={6}>
//             <FormControl fullWidth variant="standard">
//               <InputLabel>Color de Fondo</InputLabel>
//               <Select
//                 name="background"
//                 value={block.background || "sin_fondo"}
//                 onChange={handleSelectChange}
//                 disabled={disabled}
//               >
//                 <MenuItem value="sin_fondo">Sin fondo</MenuItem>
//                 <MenuItem value="claro">Claro</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* ---------------------------------------------------------------------- */}
//           {/* CASO BANNER */}
//           {/* ---------------------------------------------------------------------- */}
//           {block.type === "banner" && (
//             <>
//               {/* Altura de la imagen */}
//               <Grid item xs={12} sm={6}>
//                 <FormControl variant="standard" fullWidth>
//                   <InputLabel>Altura de la imagen</InputLabel>
//                   <Select
//                     value={block.imageHeight || "normal"}
//                     onChange={(e) =>
//                       onChange(
//                         { ...block, imageHeight: e.target.value as any },
//                         index
//                       )
//                     }
//                     disabled={disabled}
//                   >
//                     <MenuItem value="muy_alto">Muy alto</MenuItem>
//                     <MenuItem value="alto">Alto</MenuItem>
//                     <MenuItem value="normal">Normal</MenuItem>
//                     <MenuItem value="bajo">Bajo</MenuItem>
//                     <MenuItem value="muy_bajo">Muy bajo</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* Imagen Móvil */}
//               <Grid item xs={12}>
//                 <Typography variant="body2" sx={{ mb: 1 }}>
//                   Imagen Móvil
//                 </Typography>
//                 <DragDrop
//                   disabled={disabled}
//                   maxSizeMB={2}
//                   id={`banner-mobile-${index}`}
//                   valueDefault={block.imageMobile}
//                   directoryNameList={["home-banner", "mobile"]}
//                   typeAllowed={["image/*"]}
//                   isOnlyOneFile
//                   isBlob
//                   showFileList={false}
//                   handleFiles={(files) => {
//                     if (files.length > 0 && files[0].blob) {
//                       const url = URL.createObjectURL(files[0].blob);
//                       onChange({ ...block, imageMobile: url }, index);
//                     } else if (files.length === 0) {
//                       onChange({ ...block, imageMobile: "" }, index);
//                     }
//                   }}
//                 />
//               </Grid>

//               {/* Imagen Tablet */}
//               <Grid item xs={12}>
//                 <Typography variant="body2" sx={{ mb: 1 }}>
//                   Imagen Tablet
//                 </Typography>
//                 <DragDrop
//                   disabled={disabled}
//                   maxSizeMB={2}
//                   id={`banner-tablet-${index}`}
//                   valueDefault={block.imageTablet}
//                   directoryNameList={["home-banner", "tablet"]}
//                   typeAllowed={["image/*"]}
//                   isOnlyOneFile
//                   isBlob
//                   showFileList={false}
//                   handleFiles={(files) => {
//                     if (files.length > 0 && files[0].blob) {
//                       const url = URL.createObjectURL(files[0].blob);
//                       onChange({ ...block, imageTablet: url }, index);
//                     } else if (files.length === 0) {
//                       onChange({ ...block, imageTablet: "" }, index);
//                     }
//                   }}
//                 />
//               </Grid>

//               {/* Imagen Desktop */}
//               <Grid item xs={12}>
//                 <Typography variant="body2" sx={{ mb: 1 }}>
//                   Imagen Escritorio
//                 </Typography>
//                 <DragDrop
//                   disabled={disabled}
//                   maxSizeMB={2}
//                   id={`banner-desktop-${index}`}
//                   valueDefault={block.imageDesktop}
//                   directoryNameList={["home-banner", "desktop"]}
//                   typeAllowed={["image/*"]}
//                   isOnlyOneFile
//                   isBlob
//                   showFileList={false}
//                   handleFiles={(files) => {
//                     if (files.length > 0 && files[0].blob) {
//                       const url = URL.createObjectURL(files[0].blob);
//                       onChange({ ...block, imageDesktop: url }, index);
//                     } else if (files.length === 0) {
//                       onChange({ ...block, imageDesktop: "" }, index);
//                     }
//                   }}
//                 />
//               </Grid>

//               {/* Título */}
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   variant="standard"
//                   label="Título"
//                   value={block.title || ""}
//                   onChange={(e) => onChange({ ...block, title: e.target.value }, index)}
//                   disabled={disabled}
//                   inputRef={titleRef}
//                 />
//                 {!disabled && (
//                   <Box display="flex" justifyContent="flex-end" mt={1}>
//                     <Button
//                       variant="outlined"
//                       size="small"
//                       onClick={() => handleHighlightSelection("title")}
//                     >
//                       Destacar Selección
//                     </Button>
//                   </Box>
//                 )}
//               </Grid>

//               {/* Subtítulo */}
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   variant="standard"
//                   label="Subtítulo"
//                   value={block.subTitle || ""}
//                   onChange={(e) => onChange({ ...block, subTitle: e.target.value }, index)}
//                   disabled={disabled}
//                   inputRef={subTitleRef}
//                 />
//                 {!disabled && (
//                   <Box display="flex" justifyContent="flex-end" mt={1}>
//                     <Button
//                       variant="outlined"
//                       size="small"
//                       onClick={() => handleHighlightSelection("subTitle")}
//                     >
//                       Destacar Selección
//                     </Button>
//                   </Box>
//                 )}
//               </Grid>

//               {/* Lista de líneas */}
//               <Grid item xs={12}>
//                 <Typography variant="body2" sx={{ mb: 1 }}>
//                   Lista de líneas
//                 </Typography>
//                 {(block.textList || []).map((line, i) => (
//                   <Box key={i} display="flex" alignItems="center" gap={1} mb={1}>
//                     <TextField
//                       fullWidth
//                       variant="standard"
//                       value={line}
//                       onChange={(e) => {
//                         const newArr = [...(block.textList || [])];
//                         newArr[i] = e.target.value;
//                         onChange({ ...block, textList: newArr }, index);
//                       }}
//                       inputRef={(el) => (textLineRefs.current[i] = el)}
//                       disabled={disabled}
//                     />
//                     {!disabled && (
//                       <>
//                         <Button
//                           variant="outlined"
//                           size="small"
//                           onClick={() => handleHighlightLine(i)}
//                         >
//                           Destacar Selección
//                         </Button>
//                         <IconButton
//                           onClick={() => {
//                             const newArr = (block.textList || []).filter(
//                               (_, idx) => idx !== i
//                             );
//                             onChange({ ...block, textList: newArr }, index);
//                           }}
//                         >
//                           <Delete fontSize="small" />
//                         </IconButton>
//                       </>
//                     )}
//                   </Box>
//                 ))}
//                 {!disabled && (block.textList?.length || 0) < 10 && (
//                   <Button
//                     startIcon={<AddCircleOutline />}
//                     onClick={() => {
//                       const newArr = [...(block.textList || []), ""];
//                       onChange({ ...block, textList: newArr }, index);
//                     }}
//                     size="small"
//                   >
//                     Agregar línea
//                   </Button>
//                 )}
//               </Grid>

//               {/* Alineación del texto */}
//               <Grid item xs={12} sm={6}>
//                 <FormControl variant="standard" fullWidth>
//                   <InputLabel>Alineación</InputLabel>
//                   <Select
//                     value={block.textAlign || "left"}
//                     onChange={(e) =>
//                       onChange(
//                         { ...block, textAlign: e.target.value as any },
//                         index
//                       )
//                     }
//                     disabled={disabled}
//                   >
//                     <MenuItem value="left">Izquierda</MenuItem>
//                     <MenuItem value="center">Centrado</MenuItem>
//                     <MenuItem value="right">Derecha</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* Color del texto */}
//               <Grid item xs={12} sm={6}>
//                 <Typography variant="body2">Color del texto</Typography>
//                 <input
//                   type="color"
//                   value={block.textColor || "#000000"}
//                   disabled={disabled}
//                   onChange={(e) => onChange({ ...block, textColor: e.target.value }, index)}
//                   style={{ width: 40, height: 30, cursor: "pointer" }}
//                 />
//               </Grid>

//               {/* Botón */}
//               <Grid item xs={12}>
//                 <FormControlLabel
//                   control={
//                     <Switch
//                       checked={!!block.showButton}
//                       onChange={(e) =>
//                         onChange({ ...block, showButton: e.target.checked }, index)
//                       }
//                       disabled={disabled}
//                     />
//                   }
//                   label="¿Mostrar Botón?"
//                 />
//                 {block.showButton && (
//                   <Box mt={2} sx={{ pl: 2, borderLeft: "4px solid #ccc" }}>
//                     {/* Forma */}
//                     <FormControl variant="standard" sx={{ mb: 2, minWidth: 120 }}>
//                       <InputLabel>Forma del botón</InputLabel>
//                       <Select
//                         value={block.buttonShape || "rounded"}
//                         onChange={(e) =>
//                           onChange(
//                             { ...block, buttonShape: e.target.value as any },
//                             index
//                           )
//                         }
//                         disabled={disabled}
//                       >
//                         <MenuItem value="rounded">Bordes redondeados</MenuItem>
//                         <MenuItem value="square">Bordes rectos</MenuItem>
//                       </Select>
//                     </FormControl>

//                     {/* Colores */}
//                     <Box display="flex" alignItems="center" gap={4} mb={2}>
//                       <Box>
//                         <Typography variant="body2">Color Botón</Typography>
//                         <input
//                           type="color"
//                           value={block.buttonBgColor || "#0066cc"}
//                           disabled={disabled}
//                           onChange={(e) =>
//                             onChange({ ...block, buttonBgColor: e.target.value }, index)
//                           }
//                           style={{ width: 40, height: 30, cursor: "pointer" }}
//                         />
//                       </Box>
//                       <Box>
//                         <Typography variant="body2">Color Texto Botón</Typography>
//                         <input
//                           type="color"
//                           value={block.buttonTextColor || "#ffffff"}
//                           disabled={disabled}
//                           onChange={(e) =>
//                             onChange({ ...block, buttonTextColor: e.target.value }, index)
//                           }
//                           style={{ width: 40, height: 30, cursor: "pointer" }}
//                         />
//                       </Box>
//                     </Box>

//                     {/* Texto y enlace */}
//                     <TextField
//                       variant="standard"
//                       label="Texto del botón"
//                       value={block.buttonText || ""}
//                       onChange={(e) =>
//                         onChange({ ...block, buttonText: e.target.value }, index)
//                       }
//                       disabled={disabled}
//                       fullWidth
//                       sx={{ mb: 2 }}
//                     />
//                     <TextField
//                       variant="standard"
//                       label="Enlace del botón"
//                       value={block.buttonLink || ""}
//                       onChange={(e) =>
//                         onChange({ ...block, buttonLink: e.target.value }, index)
//                       }
//                       disabled={disabled}
//                       fullWidth
//                     />
//                   </Box>
//                 )}
//               </Grid>
//             </>
//           )}

//           {/* ---------------------------------------------------------------------- */}
//           {/* CASO "text..." => Título + Contenido + Imagen/Video opcional           */}
//           {/* ---------------------------------------------------------------------- */}
//           {block.type.startsWith("text") && (
//             <>
//               <Grid item xs={12}>
//                 <TextField
//                   variant="standard"
//                   label="Título (opcional, máx. 80 caracteres)"
//                   name="title"
//                   value={block.title || ""}
//                   onChange={handleInputChange}
//                   disabled={disabled}
//                   fullWidth
//                   inputProps={{ maxLength: 80 }}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <Box position="relative">
//                   <TextField
//                     variant="standard"
//                     label="Contenido de Texto"
//                     name="content"
//                     value={block.content || ""}
//                     onChange={handleInputChange}
//                     disabled={disabled}
//                     multiline
//                     rows={4}
//                     fullWidth
//                     placeholder="Escribe aquí..."
//                     inputProps={{ maxLength: 500 }}
//                     helperText={`${contentLength}/500 caracteres`}
//                   />
//                   <IconButton
//                     size="small"
//                     sx={{ position: "absolute", right: 14, bottom: 24 }}
//                     onClick={(e) => handleEmojiButtonClick("content", e)}
//                     disabled={disabled}
//                   >
//                     <EmojiEmotions fontSize="small" />
//                   </IconButton>
//                 </Box>
//               </Grid>
//               {block.type.includes("image") && (
//                 <Grid item xs={12}>
//                   <Typography variant="subtitle1" gutterBottom>
//                     Imagen
//                   </Typography>
//                   <DragDrop
//                     id={`contentBlock-image-${index}`}
//                     valueDefault={block.image || ""}
//                     disabled={disabled}
//                     directoryNameList={["program", "images"]}
//                     maxSizeMB={5}
//                     typeAllowed={["image/*"]}
//                     isOnlyOneFile
//                     isBlob
//                     specialCase
//                     showFileList={false}
//                     handleFiles={handleFiles}
//                   />
//                 </Grid>
//               )}
//               {block.type.includes("video") && (
//                 <Grid item xs={12}>
//                   <TextField
//                     variant="standard"
//                     label="URL de Video (YouTube)"
//                     name="videoUrl"
//                     value={block.videoUrl || ""}
//                     onChange={handleInputChange}
//                     disabled={disabled}
//                     fullWidth
//                     placeholder="https://www.youtube.com/watch?v=..."
//                   />
//                 </Grid>
//               )}
//             </>
//           )}

//           {/* ---------------------------------------------------------------------- */}
//           {/* type === "image" */}
//           {/* ---------------------------------------------------------------------- */}
//           {block.type === "image" && (
//             <Grid item xs={12}>
//               <Typography variant="subtitle1" gutterBottom>
//                 Imagen
//               </Typography>
//               <DragDrop
//                 id={`contentBlock-image-${index}`}
//                 valueDefault={block.image || ""}
//                 disabled={disabled}
//                 directoryNameList={["program", "images"]}
//                 maxSizeMB={10}
//                 typeAllowed={["image/*"]}
//                 isOnlyOneFile
//                 isBlob
//                 specialCase
//                 showFileList={false}
//                 handleFiles={handleFiles}
//               />
//             </Grid>
//           )}

//           {/* ---------------------------------------------------------------------- */}
//           {/* type === "video" */}
//           {/* ---------------------------------------------------------------------- */}
//           {block.type === "video" && (
//             <Grid item xs={12}>
//               <TextField
//                 variant="standard"
//                 label="URL de Video (YouTube)"
//                 name="videoUrl"
//                 value={block.videoUrl || ""}
//                 onChange={handleInputChange}
//                 disabled={disabled}
//                 fullWidth
//                 placeholder="https://www.youtube.com/watch?v=..."
//               />
//             </Grid>
//           )}

//           {/* ---------------------------------------------------------------------- */}
//           {/* type === "quote" */}
//           {/* ---------------------------------------------------------------------- */}
//           {block.type === "quote" && (
//             <Grid item xs={12}>
//               <Box position="relative">
//                 <TextField
//                   variant="standard"
//                   label="Cita"
//                   name="quote"
//                   value={block.quote || ""}
//                   onChange={handleInputChange}
//                   disabled={disabled}
//                   multiline
//                   rows={3}
//                   fullWidth
//                   placeholder="Escribe la cita aquí..."
//                 />
//                 <IconButton
//                   size="small"
//                   sx={{ position: "absolute", right: 14, bottom: 24 }}
//                   onClick={(e) => handleEmojiButtonClick("quote", e)}
//                   disabled={disabled}
//                 >
//                   <EmojiEmotions fontSize="small" />
//                 </IconButton>
//               </Box>
//             </Grid>
//           )}

//           {/* ---------------------------------------------------------------------- */}
//           {/* type === "list" */}
//           {/* ---------------------------------------------------------------------- */}
//           {block.type === "list" && (
//             <>
//               <Grid item xs={12}>
//                 <TextField
//                   variant="standard"
//                   label="Título del Listado (opcional, máx. 80 caracteres)"
//                   name="title"
//                   value={block.title || ""}
//                   onChange={handleInputChange}
//                   disabled={disabled}
//                   fullWidth
//                   inputProps={{ maxLength: 80 }}
//                   sx={{ mb: 1 }}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <Typography variant="subtitle1" gutterBottom>
//                   Imagen del Listado (opcional)
//                 </Typography>
//                 <DragDrop
//                   id={`contentBlock-listImage-${index}`}
//                   valueDefault={block.image || ""}
//                   disabled={disabled}
//                   directoryNameList={["program", "images"]}
//                   maxSizeMB={5}
//                   typeAllowed={["image/*"]}
//                   isOnlyOneFile
//                   isBlob
//                   specialCase
//                   showFileList={false}
//                   handleFiles={handleFiles}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <Typography variant="subtitle1" gutterBottom>
//                   Puntos Claves
//                 </Typography>
//                 {block.listItems?.map((item, i) => (
//                   <Box key={i} display="flex" alignItems="center" mb={1}>
//                     <TextField
//                       variant="standard"
//                       label={`Punto ${i + 1}`}
//                       value={item}
//                       onChange={(e) => handleListItemChange(e.target.value, i)}
//                       disabled={disabled}
//                       fullWidth
//                     />
//                     <IconButton
//                       onClick={(e) => handleEmojiButtonClick("listItem", e, i)}
//                       disabled={disabled}
//                       aria-label="Agregar Emoji"
//                       color="primary"
//                     >
//                       <EmojiEmotions />
//                     </IconButton>
//                     <IconButton
//                       onClick={() => handleRemoveListItem(i)}
//                       disabled={disabled}
//                       aria-label="Eliminar punto"
//                       color="error"
//                     >
//                       <Cancel />
//                     </IconButton>
//                   </Box>
//                 ))}
//                 {block.listItems && block.listItems.length < 10 && (
//                   <Button
//                     variant="contained"
//                     startIcon={<AddIcon />}
//                     onClick={handleAddListItem}
//                     disabled={disabled}
//                   >
//                     Agregar Punto
//                   </Button>
//                 )}
//               </Grid>
//             </>
//           )}

//           {/* ---------------------------------------------------------------------- */}
//           {/* type === "testimonial" */}
//           {/* ---------------------------------------------------------------------- */}
//           {block.type === "testimonial" && (
//             <Grid item xs={12}>
//               <Typography variant="subtitle1" gutterBottom>
//                 Testimonios
//               </Typography>
//               {block.testimonials?.map((test, tIndex) => (
//                 <Box
//                   key={tIndex}
//                   mb={2}
//                   border="1px solid #ddd"
//                   borderRadius={2}
//                   p={2}
//                 >
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <TextField
//                         variant="standard"
//                         label="Nombre (máx. 80 caracteres)"
//                         name={`testimonialName_${tIndex}`}
//                         value={test.testimonialName || ""}
//                         onChange={(e) =>
//                           handleTestimonialChange(e, tIndex, "testimonialName")
//                         }
//                         disabled={disabled}
//                         fullWidth
//                         inputProps={{ maxLength: 80 }}
//                       />
//                     </Grid>
//                     <Grid item xs={12}>
//                       <Box position="relative">
//                         <TextField
//                           variant="standard"
//                           label="Descripción"
//                           name={`testimonialDescription_${tIndex}`}
//                           value={test.testimonialDescription || ""}
//                           onChange={(e) =>
//                             handleTestimonialChange(
//                               e,
//                               tIndex,
//                               "testimonialDescription"
//                             )
//                           }
//                           disabled={disabled}
//                           multiline
//                           rows={4}
//                           fullWidth
//                           placeholder="Escribe la descripción..."
//                           inputProps={{ maxLength: 225 }}
//                           helperText={`${test.testimonialDescription?.length ?? 0}/225 caracteres`}
//                         />
//                         <IconButton
//                           size="small"
//                           sx={{ position: "absolute", right: 14, bottom: 24 }}
//                           onClick={(e) =>
//                             handleEmojiButtonClick(
//                               "testimonialDescription",
//                               e,
//                               tIndex
//                             )
//                           }
//                           disabled={disabled}
//                         >
//                           <EmojiEmotions fontSize="small" />
//                         </IconButton>
//                       </Box>
//                     </Grid>
//                     <Grid item xs={12}>
//                       <Button
//                         variant="outlined"
//                         color="error"
//                         onClick={() => handleRemoveTestimonial(tIndex)}
//                         disabled={
//                           disabled ||
//                           (block.testimonials &&
//                             block.testimonials.length === 1)
//                         }
//                       >
//                         Eliminar Testimonio
//                       </Button>
//                     </Grid>
//                   </Grid>
//                 </Box>
//               ))}
//               {block.testimonials && block.testimonials.length < 8 && (
//                 <Button
//                   variant="contained"
//                   startIcon={<AddIcon />}
//                   onClick={handleAddTestimonial}
//                   disabled={disabled}
//                 >
//                   Agregar Testimonio
//                 </Button>
//               )}
//             </Grid>
//           )}

//           {/* ---------------------------------------------------------------------- */}
//           {/* type === "image_text_block" */}
//           {/* ---------------------------------------------------------------------- */}
//           {block.type === "image_text_block" && (
//             <Grid item xs={12}>
//               <Typography variant="h6" gutterBottom>
//                 Bloque de Imágenes con Texto
//               </Typography>
//               {block.imageTextItems?.map((item, i) => (
//                 <Grid
//                   container
//                   spacing={2}
//                   key={i}
//                   alignItems="center"
//                   sx={{ mb: 2 }}
//                 >
//                   <Grid item xs={12} sm={4}>
//                     <DragDrop
//                       id={`contentBlock-imageText-${index}-${i}`}
//                       valueDefault={item.image || ""}
//                       disabled={disabled}
//                       directoryNameList={["program", "images"]}
//                       maxSizeMB={5}
//                       typeAllowed={["image/*"]}
//                       isOnlyOneFile
//                       isBlob
//                       specialCase
//                       showFileList={false}
//                       handleFiles={(files) => {
//                         handleListImageFiles(
//                           files,
//                           block.imageTextItems || [],
//                           i
//                         );
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={7}>
//                     <TextField
//                       variant="standard"
//                       label="Texto"
//                       value={item.text}
//                       onChange={(e) => {
//                         const newItems = block.imageTextItems
//                           ? [...block.imageTextItems]
//                           : [];
//                         newItems[i] = { ...newItems[i], text: e.target.value };
//                         onChange({ ...block, imageTextItems: newItems }, index);
//                       }}
//                       disabled={disabled}
//                       fullWidth
//                       multiline
//                       rows={2}
//                       inputProps={{ maxLength: 225 }}
//                       helperText={`${item.text.length}/225 caracteres`}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={1}>
//                     <IconButton
//                       onClick={() => {
//                         const newItems =
//                           block.imageTextItems?.filter((_, j) => j !== i) ||
//                           [];
//                         onChange({ ...block, imageTextItems: newItems }, index);
//                       }}
//                       disabled={disabled}
//                     >
//                       <Cancel />
//                     </IconButton>
//                   </Grid>
//                 </Grid>
//               ))}
//               {(!block.imageTextItems || block.imageTextItems.length < 6) && (
//                 <Button
//                   variant="outlined"
//                   startIcon={<AddIcon />}
//                   onClick={() => {
//                     const newItems = block.imageTextItems
//                       ? [...block.imageTextItems, { text: "" }]
//                       : [{ text: "" }];
//                     onChange({ ...block, imageTextItems: newItems }, index);
//                   }}
//                   disabled={disabled}
//                 >
//                   Agregar Elemento
//                 </Button>
//               )}
//             </Grid>
//           )}
//         </Grid>
//       </Box>

//       {/* Popover Emoji */}
//       <Popover
//         open={Boolean(emojiPickerState?.anchorEl)}
//         anchorEl={emojiPickerState?.anchorEl}
//         onClose={handleEmojiClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         transformOrigin={{ vertical: "bottom", horizontal: "left" }}
//       >
//         <Box p={1}>
//           <Picker data={data} onEmojiSelect={handleEmojiSelect} />
//         </Box>
//       </Popover>
//     </Paper>
//   );
// };

// export default ContentBlockFormHome;

"use client";

import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  IconButton,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Paper,
  SelectChangeEvent,
  Button,
  Popover,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormControlLabel,
  Switch,
  // Importamos los componentes de Table y Radio para la nueva opción
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Radio,
} from "@mui/material";
import {
  Cancel,
  Add as AddIcon,
  EmojiEmotions,
  ArrowUpward,
  ArrowDownward,
  AddCircleOutline,
  Delete,
} from "@mui/icons-material";

import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import DragDrop from "../../components/drag-drop/DragDrop";
import { Program } from "../../../core/models/db";
import { useProgram } from "../../../core/hooks/db/fisioteduca/useFisioteduca";

/**
 * Interfaz unificada con TODOS los tipos,
 * incluyendo las propiedades para 'banner'.
 */
export interface ContentBlock {
  type: string;

  /* Para "text", "text_image_*", "text_video_*", etc. */
  title?: string;    // máx. 80
  content?: string;  // máx. 500
  quote?: string;
  image?: string;    // para 'image', 'listImage', o 'text_image_*'
  videoUrl?: string;

  /* Para "list" */
  listItems?: string[];
  // (Opcionalmente podrías usar listImage?: string; si la quieres separar)

  /* Para "testimonial" */
  testimonials?: {
    testimonialName: string;
    testimonialDescription: string;
  }[];

  /* Para "image_text_block" */
  imageTextItems?: { image?: string; text: string }[];

  /* El background ("sin_fondo", "claro") */
  background?: string;

  /* ------- PARA EL "banner" ------- */
  // Distintas imágenes para responsive
  imageMobile?: string;
  imageTablet?: string;
  imageDesktop?: string;
  imageHeight?: "muy_alto" | "alto" | "normal" | "bajo" | "muy_bajo";
  imageLink?: string;

  // Texto principal
  subTitle?: string;         // Subtítulo
  textList?: string[];       // Array de líneas
  textAlign?: "left" | "center" | "right";
  textColor?: string;

  // Botón
  showButton?: boolean;
  buttonShape?: "rounded" | "square";
  buttonBgColor?: string;
  buttonTextColor?: string;
  buttonText?: string;
  buttonLink?: string;

  // NUEVAS PROPIEDADES PARA BANNER
  showProgramPrice?: boolean;
  programId?: string;
}

// Para el EmojiPicker
interface EmojiPickerState {
  anchorEl: HTMLElement | null;
  field: string | null;
  listItemIndex?: number;
}

interface ContentBlockFormProps {
  index: number;
  block: ContentBlock;
  onChange: (block: ContentBlock, index: number) => void;
  onRemove: (index: number) => void;
  onReorder: (oldIndex: number, newIndex: number) => void;
  maxPosition: number;
  disabled?: boolean;
}

const ContentBlockFormHome: React.FC<ContentBlockFormProps> = ({
  index,
  block,
  onChange,
  onRemove,
  onReorder,
  maxPosition,
  disabled,
}) => {
  const [openReorderModal, setOpenReorderModal] = useState(false);
  const [desiredPosition, setDesiredPosition] = useState(index + 1);

  const { getPrograms } = useProgram();
  const [programList, setProgramList] = useState<Program[]>([]);
  const [programSelected, setProgramSelected] = useState<Program | null>(null);

  const getProgramsAction = async () => {
    // Nota: recuerda ajustar la validación según tu lógica; en este ejemplo se usa un simple check.
    if (programList.length > 0) return;

    try {
      const response = await getPrograms({
        page: 1,
        itemsPerPage: 200,
      });

      console.log("Programas", response);
      if (response?.ok && response.item.rows.length > 0) {
        // Asumimos que response.item.rows es un array de Program
        setProgramList(response.item.rows);
      } else {
        setProgramList([]);
      }
    } catch (error) {
      console.error("Error al obtener programas", error);
      setProgramList([]);
    }
  };

  useEffect(() => {
    if (block.type === "banner") {
      getProgramsAction();
    }
  }, [block.type]);

  // Para el EmojiPicker
  const [emojiPickerState, setEmojiPickerState] = useState<EmojiPickerState | null>(null);

  // ========== Para Banner (destacar selección) ==========
  const titleRef = useRef<HTMLTextAreaElement | HTMLInputElement>(null);
  const subTitleRef = useRef<HTMLTextAreaElement | HTMLInputElement>(null);
  const textLineRefs = useRef<(HTMLInputElement | null)[]>([]);

  // Mover / Eliminar
  const handleRemoveBlock = () => onRemove(index);
  const handleMoveUp = () => onReorder(index, index - 1);
  const handleMoveDown = () => onReorder(index, index + 1);

  // =========================================================
  // 1) Cambiar el "type" => reiniciar campos según sea necesario
  // =========================================================
  const handleTypeChange = (e: SelectChangeEvent<string>) => {
    const selectedType = e.target.value;

    let newBlock: ContentBlock = {
      type: selectedType,
      background: "sin_fondo",
    };

    if (selectedType.startsWith("text")) {
      newBlock.title = "";
      newBlock.content = "";
    } else if (selectedType === "image") {
      newBlock.image = "";
    } else if (selectedType === "video") {
      newBlock.videoUrl = "";
    } else if (selectedType === "quote") {
      newBlock.quote = "";
    } else if (selectedType === "list") {
      newBlock.title = "";
      newBlock.listItems = [""];
    } else if (selectedType === "testimonial") {
      newBlock.testimonials = [
        { testimonialName: "", testimonialDescription: "" },
      ];
    } else if (selectedType === "image_text_block") {
      newBlock.imageTextItems = [{ text: "" }];
    } else if (selectedType === "banner") {
      // Inicializamos las propiedades del banner
      newBlock.imageMobile = "";
      newBlock.imageTablet = "";
      newBlock.imageDesktop = "";
      newBlock.imageHeight = "normal";
      newBlock.title = "";
      newBlock.subTitle = "";
      newBlock.textList = [];
      newBlock.textColor = "#000000";
      newBlock.textAlign = "left";
      newBlock.showButton = false;
      newBlock.buttonShape = "rounded";
      newBlock.buttonBgColor = "#0066cc";
      newBlock.buttonTextColor = "#ffffff";
      // NUEVA OPCIÓN: Mostrar precio del Programa (por defecto desactivado)
      newBlock.showProgramPrice = false;
      newBlock.programId = "";
    }

    onChange(newBlock, index);
  };

  // =========================================================
  // 2) Handlers genéricos (inputs, selects)
  // =========================================================
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange({ ...block, [e.target.name]: e.target.value }, index);
  };

  const handleSelectChange = (e: SelectChangeEvent<string>) => {
    onChange({ ...block, [e.target.name]: e.target.value }, index);
  };

  // =========================================================
  // 3) Drag & Drop: imagen principal (p.ej., para "image", "listImage", etc.)
  // =========================================================
  const handleFiles = (files: any[]) => {
    if (files.length > 0 && files[0].blob) {
      const file = files[0];
      const url = URL.createObjectURL(file.blob);
      onChange({ ...block, image: url }, index);
    } else if (files.length === 0) {
      onChange({ ...block, image: "" }, index);
    }
  };

  // =========================================================
  // 4) LIST (listItems)
  // =========================================================
  const handleListItemChange = (itemValue: string, itemIndex: number) => {
    if (!block.listItems) return;
    const newListItems = [...block.listItems];
    newListItems[itemIndex] = itemValue;
    onChange({ ...block, listItems: newListItems }, index);
  };
  const handleAddListItem = () => {
    if (!block.listItems) return;
    if (block.listItems.length >= 10) return;
    onChange({ ...block, listItems: [...block.listItems, ""] }, index);
  };
  const handleRemoveListItem = (itemIndex: number) => {
    if (!block.listItems) return;
    const newItems = block.listItems.filter((_, i) => i !== itemIndex);
    onChange({ ...block, listItems: newItems }, index);
  };

  // =========================================================
  // 5) TESTIMONIAL
  // =========================================================
  const handleTestimonialChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    tIndex: number,
    field: "testimonialName" | "testimonialDescription"
  ) => {
    if (!block.testimonials) return;
    const newTestimonials = [...block.testimonials];
    newTestimonials[tIndex] = {
      ...newTestimonials[tIndex],
      [field]: e.target.value,
    };
    onChange({ ...block, testimonials: newTestimonials }, index);
  };
  const handleAddTestimonial = () => {
    if (block.testimonials && block.testimonials.length < 8) {
      onChange(
        {
          ...block,
          testimonials: [
            ...block.testimonials,
            { testimonialName: "", testimonialDescription: "" },
          ],
        },
        index
      );
    }
  };
  const handleRemoveTestimonial = (tIndex: number) => {
    if (!block.testimonials) return;
    const newTestimonials = block.testimonials.filter((_, i) => i !== tIndex);
    onChange({ ...block, testimonials: newTestimonials }, index);
  };

  // =========================================================
  // 6) image_text_block
  // =========================================================
  const handleListImageFiles = (
    files: any[],
    blockArray: { image?: string; text: string }[],
    itemIndex: number
  ) => {
    const newItems = blockArray ? [...blockArray] : [];
    if (files.length > 0 && files[0].blob) {
      const file = files[0];
      const url = URL.createObjectURL(file.blob);
      newItems[itemIndex] = { ...newItems[itemIndex], image: url };
    } else if (files.length === 0) {
      newItems[itemIndex] = { ...newItems[itemIndex], image: "" };
    }
    onChange({ ...block, imageTextItems: newItems }, index);
  };

  // =========================================================
  // 7) EmojiPicker
  // =========================================================
  const handleEmojiButtonClick = (
    field: string,
    e: React.MouseEvent<HTMLElement>,
    listItemIndex?: number
  ) => {
    if (disabled) return;
    setEmojiPickerState({ anchorEl: e.currentTarget, field, listItemIndex });
  };

  const handleEmojiSelect = (emoji: any) => {
    if (!emojiPickerState || !emojiPickerState.field) return;
    const emojiChar = emoji.native;

    // List item
    if (
      emojiPickerState.field === "listItem" &&
      typeof emojiPickerState.listItemIndex === "number" &&
      block.listItems
    ) {
      const i = emojiPickerState.listItemIndex;
      const newText = block.listItems[i] + emojiChar;
      handleListItemChange(newText, i);
    }
    // Testimonial description
    else if (
      emojiPickerState.field === "testimonialDescription" &&
      typeof emojiPickerState.listItemIndex === "number" &&
      block.testimonials
    ) {
      const i = emojiPickerState.listItemIndex;
      const oldText = block.testimonials[i].testimonialDescription || "";
      const newText = oldText + emojiChar;
      handleTestimonialChange(
        { target: { value: newText } } as any,
        i,
        "testimonialDescription"
      );
    }
    // En caso de "quote", "content", etc.
    else {
      const fieldName = emojiPickerState.field as keyof ContentBlock;
      const currentText = block[fieldName] || "";
      onChange({ ...block, [fieldName]: currentText + emojiChar }, index);
    }
    setEmojiPickerState(null);
  };

  const handleEmojiClose = () => setEmojiPickerState(null);

  // =========================================================
  // 8) "Destacar Selección" (exclusivo BANNER)
  // =========================================================
  const handleHighlightSelection = (field: "title" | "subTitle") => {
    const inputRef = field === "title" ? titleRef.current : subTitleRef.current;
    if (!inputRef) return;

    const start = inputRef.selectionStart;
    const end = inputRef.selectionEnd;
    if (start === null || end === null || start === end) return;

    const content = block[field] || "";
    const before = content.slice(0, start);
    const selection = content.slice(start, end);
    const after = content.slice(end);
    const newContent = `${before}<destacar>${selection}</destacar>${after}`;

    onChange({ ...block, [field]: newContent }, index);
  };

  const handleHighlightLine = (lineIndex: number) => {
    const input = textLineRefs.current[lineIndex];
    if (!input) return;
    const { selectionStart: start, selectionEnd: end } = input;
    if (start === null || end === null || start === end) return;

    const line = block.textList?.[lineIndex] || "";
    const before = line.slice(0, start);
    const selection = line.slice(start, end);
    const after = line.slice(end);
    const newLine = `${before}<destacar>${selection}</destacar>${after}`;

    const newList = [...(block.textList || [])];
    newList[lineIndex] = newLine;
    onChange({ ...block, textList: newList }, index);
  };

  // Para contar caracteres de "content"
  const contentLength = block.content ? block.content.length : 0;

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        mb: 3,
        backgroundColor: disabled ? "grey.100" : "background.paper",
        position: "relative",
      }}
    >
      {/* Cabecera */}
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h6">Bloque de Contenido #{index + 1}</Typography>
        </Grid>
        <Grid item>
          {!disabled && (
            <>
              <Button
                variant="outlined"
                sx={{ mr: 2 }}
                onClick={() => {
                  setDesiredPosition(index + 1);
                  setOpenReorderModal(true);
                }}
              >
                MOVER
              </Button>
              <IconButton
                onClick={() => handleRemoveBlock()}
                disabled={disabled}
                aria-label="Eliminar bloque"
                color="error"
              >
                <Cancel />
              </IconButton>
            </>
          )}
        </Grid>
      </Grid>

      {/* Diálogo para reordenar */}
      <Dialog open={openReorderModal} onClose={() => setOpenReorderModal(false)}>
        <DialogTitle>Mover Bloque de Contenido</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Indica la posición a la que deseas mover este bloque (1 a {maxPosition}).
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Posición"
            type="number"
            fullWidth
            variant="standard"
            value={desiredPosition}
            onChange={(e) => setDesiredPosition(Number(e.target.value))}
            onBlur={() => {
              let val = Number(desiredPosition);
              if (isNaN(val) || val < 1) val = 1;
              else if (val > maxPosition) val = maxPosition;
              setDesiredPosition(val);
            }}
            inputProps={{ min: 1, max: maxPosition }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenReorderModal(false)}>Cancelar</Button>
          <Button
            onClick={() => {
              onReorder(index, desiredPosition - 1);
              setOpenReorderModal(false);
            }}
            variant="contained"
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Contenido principal */}
      <Box mt={2}>
        <Grid container spacing={3}>
          {/* Seleccionar Tipo */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="standard">
              <InputLabel>Tipo de Contenido</InputLabel>
              <Select
                name="type"
                value={block.type || ""}
                onChange={handleTypeChange}
                disabled={disabled}
              >
                {/* <MenuItem value="text">Texto</MenuItem>
                <MenuItem value="text_image_right">Texto - Imagen Derecha</MenuItem>
                <MenuItem value="text_image_left">Texto - Imagen Izquierda</MenuItem>
                <MenuItem value="text_video_right">Texto - Video Derecha</MenuItem>
                <MenuItem value="text_video_left">Texto - Video Izquierda</MenuItem>
                <MenuItem value="image">Imagen</MenuItem>
                <MenuItem value="video">Video</MenuItem>
                <MenuItem value="quote">Cita</MenuItem>
                <MenuItem value="list">Listado de Puntos Claves</MenuItem>
                <MenuItem value="testimonial">Testimonios</MenuItem>
                <MenuItem value="image_text_block">Imágenes con Texto</MenuItem> */}
                {/* ¡AÑADIMOS BANNER! */}
                <MenuItem value="banner">Banner</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Color de Fondo */}
          {
            block.type !== "banner" && (
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="standard">
                  <InputLabel>Color de Fondo</InputLabel>
                  <Select
                    name="background"
                    value={block.background || "sin_fondo"}
                    onChange={handleSelectChange}
                    disabled={disabled}
                  >
                    <MenuItem value="sin_fondo">Sin fondo</MenuItem>
                    <MenuItem value="claro">Claro</MenuItem>
                    <MenuItem value="#FFD700">Amarillo brillante (Spartan)</MenuItem>
                    {/* <MenuItem value="#c40f020">Rojo (Spartan)</MenuItem>
                    <MenuItem value="#0000FF">Azul (Spartan)</MenuItem>
                    <MenuItem value="#008000">Verde (Spartan)</MenuItem> */}

                  </Select>
                </FormControl>
              </Grid>
            )
          }
          {/* <Grid item xs={12} sm={6}>
            <FormControl fullWidth variant="standard">
              <InputLabel>Color de Fondo</InputLabel>
              <Select
                name="background"
                value={block.background || "sin_fondo"}
                onChange={handleSelectChange}
                disabled={disabled}
              >
                <MenuItem value="sin_fondo">Sin fondo</MenuItem>
                <MenuItem value="claro">Claro</MenuItem>
              </Select>
            </FormControl>
          </Grid> */}

          {/* ---------------------------------------------------------------------- */}
          {/* CASO BANNER */}
          {/* ---------------------------------------------------------------------- */}
          {block.type === "banner" && (
            <>
              {/* Altura de la imagen */}
              <Grid item xs={12} sm={6}>
                <FormControl variant="standard" fullWidth>
                  <InputLabel>Altura de la imagen</InputLabel>
                  <Select
                    value={block.imageHeight || "normal"}
                    onChange={(e) =>
                      onChange(
                        { ...block, imageHeight: e.target.value as any },
                        index
                      )
                    }
                    disabled={disabled}
                  >
                    <MenuItem value="muy_alto">Muy alto</MenuItem>
                    <MenuItem value="alto">Alto</MenuItem>
                    <MenuItem value="normal">Normal</MenuItem>
                    <MenuItem value="bajo">Bajo</MenuItem>
                    <MenuItem value="muy_bajo">Muy bajo</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Imagen Móvil */}
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Imagen Móvil
                </Typography>
                <DragDrop
                  disabled={disabled}
                  maxSizeMB={5}
                  id={`banner-mobile-${index}`}
                  valueDefault={block.imageMobile}
                  directoryNameList={["home-banner", "mobile"]}
                  typeAllowed={["image/*"]}
                  isOnlyOneFile
                  isBlob
                  specialCase
                  showFileList={false}
                  handleFiles={(files) => {
                    if (files.length > 0 && files[0].blob) {
                      const url = URL.createObjectURL(files[0].blob);
                      onChange({ ...block, imageMobile: url }, index);
                    } else if (files.length === 0) {
                      onChange({ ...block, imageMobile: "" }, index);
                    }
                  }}
                />
              </Grid>

              {/* Imagen Tablet */}
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Imagen Tablet
                </Typography>
                <DragDrop
                  disabled={disabled}
                  maxSizeMB={5}
                  id={`banner-tablet-${index}`}
                  valueDefault={block.imageTablet}
                  directoryNameList={["home-banner", "tablet"]}
                  typeAllowed={["image/*"]}
                  isOnlyOneFile
                  isBlob
                  specialCase
                  showFileList={false}
                  handleFiles={(files) => {
                    if (files.length > 0 && files[0].blob) {
                      const url = URL.createObjectURL(files[0].blob);
                      onChange({ ...block, imageTablet: url }, index);
                    } else if (files.length === 0) {
                      onChange({ ...block, imageTablet: "" }, index);
                    }
                  }}
                />
              </Grid>

              {/* Imagen Desktop */}
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Imagen Escritorio
                </Typography>
                <DragDrop
                  disabled={disabled}
                  maxSizeMB={5}
                  id={`banner-desktop-${index}`}
                  valueDefault={block.imageDesktop}
                  directoryNameList={["home-banner", "desktop"]}
                  typeAllowed={["image/*"]}
                  isOnlyOneFile
                  isBlob
                  specialCase
                  showFileList={false}
                  handleFiles={(files) => {
                    if (files.length > 0 && files[0].blob) {
                      const url = URL.createObjectURL(files[0].blob);
                      onChange({ ...block, imageDesktop: url }, index);
                    } else if (files.length === 0) {
                      onChange({ ...block, imageDesktop: "" }, index);
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} sx={{ mb: 1 }}>
                <TextField
                  variant="standard"
                  label="Enlace al clicar la imagen"
                  value={block.imageLink || ""}
                  onChange={(e) =>
                    onChange({ ...block, imageLink: e.target.value }, index)
                  }
                  disabled={disabled}
                  fullWidth
                />
              </Grid>

              {/* Título */}
              {/* <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="standard"
                  label="Título"
                  value={block.title || ""}
                  onChange={(e) => onChange({ ...block, title: e.target.value }, index)}
                  disabled={disabled}
                  inputRef={titleRef}
                />
                {!disabled && (
                  <Box display="flex" justifyContent="flex-end" mt={1}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handleHighlightSelection("title")}
                    >
                      Destacar Selección
                    </Button>
                  </Box>
                )}
              </Grid> */}

              {/* Subtítulo */}
              {/* <Grid item xs={12} >
                <TextField
                  fullWidth
                  variant="standard"
                  label="Subtítulo"
                  value={block.subTitle || ""}
                  onChange={(e) => onChange({ ...block, subTitle: e.target.value }, index)}
                  disabled={disabled}
                  inputRef={subTitleRef}
                />
                {!disabled && (
                  <Box display="flex" justifyContent="flex-end" mt={1}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handleHighlightSelection("subTitle")}
                    >
                      Destacar Selección
                    </Button>
                  </Box>
                )}
              </Grid> */}

              {/* Lista de líneas */}
              {/* <Grid item xs={12}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Lista de líneas
                </Typography>
                {(block.textList || []).map((line, i) => (
                  <Box key={i} display="flex" alignItems="center" gap={1} mb={1}>
                    <TextField
                      fullWidth
                      variant="standard"
                      value={line}
                      onChange={(e) => {
                        const newArr = [...(block.textList || [])];
                        newArr[i] = e.target.value;
                        onChange({ ...block, textList: newArr }, index);
                      }}
                      inputRef={(el) => (textLineRefs.current[i] = el)}
                      disabled={disabled}
                    />
                    {!disabled && (
                      <>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => handleHighlightLine(i)}
                        >
                          Destacar Selección
                        </Button>
                        <IconButton
                          onClick={() => {
                            const newArr = (block.textList || []).filter(
                              (_, idx) => idx !== i
                            );
                            onChange({ ...block, textList: newArr }, index);
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </>
                    )}
                  </Box>
                ))}
                {!disabled && (block.textList?.length || 0) < 10 && (
                  <Button
                    startIcon={<AddCircleOutline />}
                    onClick={() => {
                      const newArr = [...(block.textList || []), ""];
                      onChange({ ...block, textList: newArr }, index);
                    }}
                    size="small"
                  >
                    Agregar línea
                  </Button>
                )}
              </Grid> */}

              {/* Alineación del texto */}
              {/* <Grid item xs={12} sm={6}>
                <FormControl variant="standard" fullWidth>
                  <InputLabel>Alineación</InputLabel>
                  <Select
                    value={block.textAlign || "left"}
                    onChange={(e) =>
                      onChange(
                        { ...block, textAlign: e.target.value as any },
                        index
                      )
                    }
                    disabled={disabled}
                  >
                    <MenuItem value="left">Izquierda</MenuItem>
                    <MenuItem value="center">Centrado</MenuItem>
                    <MenuItem value="right">Derecha</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}

              {/* Color del texto */}
              {/* <Grid item xs={12} sm={6}>
                <Typography variant="body2">Color del texto</Typography>
                <input
                  type="color"
                  value={block.textColor || "#000000"}
                  disabled={disabled}
                  onChange={(e) => onChange({ ...block, textColor: e.target.value }, index)}
                  style={{ width: 40, height: 30, cursor: "pointer" }}
                />
              </Grid> */}

              {/* Botón */}
              {/* <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!block.showButton}
                      onChange={(e) =>
                        onChange({ ...block, showButton: e.target.checked }, index)
                      }
                      disabled={disabled}
                    />
                  }
                  label="¿Mostrar Botón?"
                />
                {block.showButton && (
                  <Box mt={2} sx={{ pl: 2, borderLeft: "4px solid #ccc" }}>
                 
                    <FormControl variant="standard" sx={{ mb: 2, minWidth: 120 }}>
                      <InputLabel>Forma del botón</InputLabel>
                      <Select
                        value={block.buttonShape || "rounded"}
                        onChange={(e) =>
                          onChange(
                            { ...block, buttonShape: e.target.value as any },
                            index
                          )
                        }
                        disabled={disabled}
                      >
                        <MenuItem value="rounded">Bordes redondeados</MenuItem>
                        <MenuItem value="square">Bordes rectos</MenuItem>
                      </Select>
                    </FormControl> */}

              {/* Colores */}
              {/* <Box display="flex" alignItems="center" gap={4} mb={2}>
                      <Box>
                        <Typography variant="body2">Color Botón</Typography>
                        <input
                          type="color"
                          value={block.buttonBgColor || "#0066cc"}
                          disabled={disabled}
                          onChange={(e) =>
                            onChange({ ...block, buttonBgColor: e.target.value }, index)
                          }
                          style={{ width: 40, height: 30, cursor: "pointer" }}
                        />
                      </Box>
                      <Box>
                        <Typography variant="body2">Color Texto Botón</Typography>
                        <input
                          type="color"
                          value={block.buttonTextColor || "#ffffff"}
                          disabled={disabled}
                          onChange={(e) =>
                            onChange({ ...block, buttonTextColor: e.target.value }, index)
                          }
                          style={{ width: 40, height: 30, cursor: "pointer" }}
                        />
                      </Box>
                    </Box> */}

              {/* Texto y enlace */}
              {/* <TextField
                      variant="standard"
                      label="Texto del botón"
                      value={block.buttonText || ""}
                      onChange={(e) =>
                        onChange({ ...block, buttonText: e.target.value }, index)
                      }
                      disabled={disabled}
                      fullWidth
                      sx={{ mb: 2 }}
                    />
                    <TextField
                      variant="standard"
                      label="Enlace del botón"
                      value={block.buttonLink || ""}
                      onChange={(e) =>
                        onChange({ ...block, buttonLink: e.target.value }, index)
                      }
                      disabled={disabled}
                      fullWidth
                    /> */}
              {/* </Box>
                )} */}
              {/* </Grid> */}

              {/* NUEVA OPCIÓN: Mostrar precio del Programa */}
              {/* <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={block.showProgramPrice || false}
                      onChange={(e) =>
                        onChange({ ...block, showProgramPrice: e.target.checked }, index)
                      }
                      disabled={disabled}
                    />
                  }
                  label="¿Mostrar precio del Programa?"
                />
              </Grid>

              {block.showProgramPrice && (
                <Grid item xs={12}>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Seleccionar</TableCell>
                          <TableCell>Nombre</TableCell>
                          <TableCell>Precio</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {programList.slice(0, 10).map((program) => (
                          <TableRow
                            key={program.id}
                            hover
                            selected={programSelected?.id === program.id}
                            onClick={() => {
                              setProgramSelected(program);
                              onChange({ ...block, programId: program.id }, index);
                            }}
                          >
                            <TableCell>
                              <Radio
                                checked={programSelected?.id === program.id}
                                value={program.id}
                                name="program-radio"
                                inputProps={{ "aria-label": program.title }}
                              />
                            </TableCell>
                            <TableCell>{program.title}</TableCell>
                            <TableCell>{program.price}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              )} */}
            </>
          )}

          {/* ---------------------------------------------------------------------- */}
          {/* CASO "text..." => Título + Contenido + Imagen/Video opcional           */}
          {/* ---------------------------------------------------------------------- */}
          {block.type.startsWith("text") && (
            <>
              <Grid item xs={12}>
                <TextField
                  variant="standard"
                  label="Título (opcional, máx. 80 caracteres)"
                  name="title"
                  value={block.title || ""}
                  onChange={handleInputChange}
                  disabled={disabled}
                  fullWidth
                  inputProps={{ maxLength: 80 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Box position="relative">
                  <TextField
                    variant="standard"
                    label="Contenido de Texto"
                    name="content"
                    value={block.content || ""}
                    onChange={handleInputChange}
                    disabled={disabled}
                    multiline
                    rows={4}
                    fullWidth
                    placeholder="Escribe aquí..."
                    inputProps={{ maxLength: 500 }}
                    helperText={`${contentLength}/500 caracteres`}
                  />
                  <IconButton
                    size="small"
                    sx={{ position: "absolute", right: 14, bottom: 24 }}
                    onClick={(e) => handleEmojiButtonClick("content", e)}
                    disabled={disabled}
                  >
                    <EmojiEmotions fontSize="small" />
                  </IconButton>
                </Box>
              </Grid>
              {block.type.includes("image") && (
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Imagen
                  </Typography>
                  <DragDrop
                    id={`contentBlock-image-${index}`}
                    valueDefault={block.image || ""}
                    disabled={disabled}
                    directoryNameList={["program", "images"]}
                    maxSizeMB={5}
                    typeAllowed={["image/*"]}
                    isOnlyOneFile
                    isBlob
                    specialCase
                    showFileList={false}
                    handleFiles={handleFiles}
                  />
                </Grid>
              )}
              {block.type.includes("video") && (
                <Grid item xs={12}>
                  <TextField
                    variant="standard"
                    label="URL de Video (YouTube)"
                    name="videoUrl"
                    value={block.videoUrl || ""}
                    onChange={handleInputChange}
                    disabled={disabled}
                    fullWidth
                    placeholder="https://www.youtube.com/watch?v=..."
                  />
                </Grid>
              )}
            </>
          )}

          {/* ---------------------------------------------------------------------- */}
          {/* type === "image" */}
          {/* ---------------------------------------------------------------------- */}
          {block.type === "image" && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                Imagen
              </Typography>
              <DragDrop
                id={`contentBlock-image-${index}`}
                valueDefault={block.image || ""}
                disabled={disabled}
                directoryNameList={["program", "images"]}
                maxSizeMB={10}
                typeAllowed={["image/*"]}
                isOnlyOneFile
                isBlob
                specialCase
                showFileList={false}
                handleFiles={handleFiles}
              />
            </Grid>
          )}

          {/* ---------------------------------------------------------------------- */}
          {/* type === "video" */}
          {/* ---------------------------------------------------------------------- */}
          {block.type === "video" && (
            <Grid item xs={12}>
              <TextField
                variant="standard"
                label="URL de Video (YouTube)"
                name="videoUrl"
                value={block.videoUrl || ""}
                onChange={handleInputChange}
                disabled={disabled}
                fullWidth
                placeholder="https://www.youtube.com/watch?v=..."
              />
            </Grid>
          )}

          {/* ---------------------------------------------------------------------- */}
          {/* type === "quote" */}
          {/* ---------------------------------------------------------------------- */}
          {block.type === "quote" && (
            <Grid item xs={12}>
              <Box position="relative">
                <TextField
                  variant="standard"
                  label="Cita"
                  name="quote"
                  value={block.quote || ""}
                  onChange={handleInputChange}
                  disabled={disabled}
                  multiline
                  rows={3}
                  fullWidth
                  placeholder="Escribe la cita aquí..."
                />
                <IconButton
                  size="small"
                  sx={{ position: "absolute", right: 14, bottom: 24 }}
                  onClick={(e) => handleEmojiButtonClick("quote", e)}
                  disabled={disabled}
                >
                  <EmojiEmotions fontSize="small" />
                </IconButton>
              </Box>
            </Grid>
          )}

          {/* ---------------------------------------------------------------------- */}
          {/* type === "list" */}
          {/* ---------------------------------------------------------------------- */}
          {block.type === "list" && (
            <>
              <Grid item xs={12}>
                <TextField
                  variant="standard"
                  label="Título del Listado (opcional, máx. 80 caracteres)"
                  name="title"
                  value={block.title || ""}
                  onChange={handleInputChange}
                  disabled={disabled}
                  fullWidth
                  inputProps={{ maxLength: 80 }}
                  sx={{ mb: 1 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Imagen del Listado (opcional)
                </Typography>
                <DragDrop
                  id={`contentBlock-listImage-${index}`}
                  valueDefault={block.image || ""}
                  disabled={disabled}
                  directoryNameList={["program", "images"]}
                  maxSizeMB={5}
                  typeAllowed={["image/*"]}
                  isOnlyOneFile
                  isBlob
                  specialCase
                  showFileList={false}
                  handleFiles={handleFiles}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Puntos Claves
                </Typography>
                {block.listItems?.map((item, i) => (
                  <Box key={i} display="flex" alignItems="center" mb={1}>
                    <TextField
                      variant="standard"
                      label={`Punto ${i + 1}`}
                      value={item}
                      onChange={(e) => handleListItemChange(e.target.value, i)}
                      disabled={disabled}
                      fullWidth
                    />
                    <IconButton
                      onClick={(e) => handleEmojiButtonClick("listItem", e, i)}
                      disabled={disabled}
                      aria-label="Agregar Emoji"
                      color="primary"
                    >
                      <EmojiEmotions />
                    </IconButton>
                    <IconButton
                      onClick={() => handleRemoveListItem(i)}
                      disabled={disabled}
                      aria-label="Eliminar punto"
                      color="error"
                    >
                      <Cancel />
                    </IconButton>
                  </Box>
                ))}
                {block.listItems && block.listItems.length < 10 && (
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleAddListItem}
                    disabled={disabled}
                  >
                    Agregar Punto
                  </Button>
                )}
              </Grid>
            </>
          )}

          {/* ---------------------------------------------------------------------- */}
          {/* type === "testimonial" */}
          {/* ---------------------------------------------------------------------- */}
          {block.type === "testimonial" && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                Testimonios
              </Typography>
              {block.testimonials?.map((test, tIndex) => (
                <Box
                  key={tIndex}
                  mb={2}
                  border="1px solid #ddd"
                  borderRadius={2}
                  p={2}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        variant="standard"
                        label="Nombre (máx. 80 caracteres)"
                        name={`testimonialName_${tIndex}`}
                        value={test.testimonialName || ""}
                        onChange={(e) =>
                          handleTestimonialChange(e, tIndex, "testimonialName")
                        }
                        disabled={disabled}
                        fullWidth
                        inputProps={{ maxLength: 80 }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Box position="relative">
                        <TextField
                          variant="standard"
                          label="Descripción"
                          name={`testimonialDescription_${tIndex}`}
                          value={test.testimonialDescription || ""}
                          onChange={(e) =>
                            handleTestimonialChange(
                              e,
                              tIndex,
                              "testimonialDescription"
                            )
                          }
                          disabled={disabled}
                          multiline
                          rows={4}
                          fullWidth
                          placeholder="Escribe la descripción..."
                          inputProps={{ maxLength: 225 }}
                          helperText={`${test.testimonialDescription?.length ?? 0}/225 caracteres`}
                        />
                        <IconButton
                          size="small"
                          sx={{ position: "absolute", right: 14, bottom: 24 }}
                          onClick={(e) =>
                            handleEmojiButtonClick(
                              "testimonialDescription",
                              e,
                              tIndex
                            )
                          }
                          disabled={disabled}
                        >
                          <EmojiEmotions fontSize="small" />
                        </IconButton>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => handleRemoveTestimonial(tIndex)}
                        disabled={
                          disabled ||
                          (block.testimonials &&
                            block.testimonials.length === 1)
                        }
                      >
                        Eliminar Testimonio
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              ))}
              {block.testimonials && block.testimonials.length < 8 && (
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={handleAddTestimonial}
                  disabled={disabled}
                >
                  Agregar Testimonio
                </Button>
              )}
            </Grid>
          )}

          {/* ---------------------------------------------------------------------- */}
          {/* type === "image_text_block" */}
          {/* ---------------------------------------------------------------------- */}
          {block.type === "image_text_block" && (
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Bloque de Imágenes con Texto
              </Typography>
              {block.imageTextItems?.map((item, i) => (
                <Grid
                  container
                  spacing={2}
                  key={i}
                  alignItems="center"
                  sx={{ mb: 2 }}
                >
                  <Grid item xs={12} sm={4}>
                    <DragDrop
                      id={`contentBlock-imageText-${index}-${i}`}
                      valueDefault={item.image || ""}
                      disabled={disabled}
                      directoryNameList={["program", "images"]}
                      maxSizeMB={5}
                      typeAllowed={["image/*"]}
                      isOnlyOneFile
                      isBlob
                      specialCase
                      showFileList={false}
                      handleFiles={(files) => {
                        handleListImageFiles(
                          files,
                          block.imageTextItems || [],
                          i
                        );
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={7}>
                    <TextField
                      variant="standard"
                      label="Texto"
                      value={item.text}
                      onChange={(e) => {
                        const newItems = block.imageTextItems
                          ? [...block.imageTextItems]
                          : [];
                        newItems[i] = { ...newItems[i], text: e.target.value };
                        onChange({ ...block, imageTextItems: newItems }, index);
                      }}
                      disabled={disabled}
                      fullWidth
                      multiline
                      rows={2}
                      inputProps={{ maxLength: 225 }}
                      helperText={`${item.text.length}/225 caracteres`}
                    />
                  </Grid>
                  <Grid item xs={12} sm={1}>
                    <IconButton
                      onClick={() => {
                        const newItems =
                          block.imageTextItems?.filter((_, j) => j !== i) ||
                          [];
                        onChange({ ...block, imageTextItems: newItems }, index);
                      }}
                      disabled={disabled}
                    >
                      <Cancel />
                    </IconButton>
                  </Grid>
                </Grid>
              ))}
              {(!block.imageTextItems || block.imageTextItems.length < 6) && (
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    const newItems = block.imageTextItems
                      ? [...block.imageTextItems, { text: "" }]
                      : [{ text: "" }];
                    onChange({ ...block, imageTextItems: newItems }, index);
                  }}
                  disabled={disabled}
                >
                  Agregar Elemento
                </Button>
              )}
            </Grid>
          )}
        </Grid>
      </Box>

      {/* Popover Emoji */}
      <Popover
        open={Boolean(emojiPickerState?.anchorEl)}
        anchorEl={emojiPickerState?.anchorEl}
        onClose={handleEmojiClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={1}>
          <Picker data={data} onEmojiSelect={handleEmojiSelect} />
        </Box>
      </Popover>
    </Paper>
  );
};

export default ContentBlockFormHome;
